import React from 'react'
import { useAuthStore } from '../../../store/authStore'

interface StatItem {
  id: number
  icon: React.ElementType // Updated this line
  value: string | number
  label: string
  label_ml?: string
}

interface StatsCardProps {
  stats: StatItem[]
}

const StatsCard: React.FC<StatsCardProps> = ({ stats }) => {
  const { language } = useAuthStore() // 'lang_eng' | 'lang_mal'

  const getLabel = (item: StatItem) => {
    return language === 'lang_mal' ? item.label_ml || item.label : item.label
  }
  return (
    <div className="bg-[#fef5f1]">
      <div className=" py-4 flex flex-wrap justify-between lg:w-8/12 px-3 lg:px-0 mx-auto  gap-12 h-full">
        {stats.map((stat) => (
          <div
            key={stat.id}
            className="flex  gap-4 items-center justify-center text-center"
          >
            <div className="text-4xl flex-flex-col items-center justify-center text-gray-700 ">
              <stat.icon /> {/* Updated here */}
            </div>
            <div className="text-left">
              <div className="font-semibold text-lg text-gray-800">
                {stat.value}
              </div>
              <div className="text-sm text-gray-500 mt-1">{getLabel(stat)}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default StatsCard
